import ximg from "../../../../assets/images/blogs/pp171/x.png";
import * as React from 'react';
export default {
  ximg,
  React
};